import { QueryClient } from "react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: Infinity, cacheTime: 0, retry: false },
  },
});

export default queryClient;
